import { gql } from "@apollo/client"

export const GET_WALLETS_FROM_MEMBER = gql`
  query GetWalletsFromMember($memberId: ID, $clientId: ID) {
    getWalletsFromMember(member_id: $memberId, client_id: $clientId) {
      id
      first_name
      last_name
      profile_member_id
      balance
      profile_name
      email
      name
      payment_method
      card_token
      stripe_id
    }
  }
`